import { envConfig } from './envConfig';

// Cypress Test Environment overrides, with mock typing based on needed Cypress functions
type CypressWindow = Window &
  typeof globalThis & {
    Cypress: {
      testingType: string;
    };
  };

const isCypressTestEnv =
  envConfig.VITE_AVA_ENV === 'local' ||
  envConfig.VITE_AVA_ENV === 'test' ||
  envConfig.VITE_AVA_ENV === 'staging' ||
  envConfig.VITE_AVA_ENV === 'uat';

export function isCypressWindow(window: Window): window is CypressWindow {
  return isCypressTestEnv && (window as CypressWindow)?.Cypress != null;
}

export function isCypressE2E(window: Window) {
  return isCypressTestEnv && (window as CypressWindow)?.Cypress?.testingType === 'e2e';
}

let _rowVirtSuppressed = false;

/** For Cypress testing, we want to have specific grid overrides setup  */
export const cypressGridSettings = {
  isRowVirtSuppressed: () => isCypressWindow(window) && _rowVirtSuppressed,
  isColVirtSuppressed: () => isCypressWindow(window),
  toggleIsRowVirtSuppressed: (isRowSuppressed: boolean) => {
    if (isCypressWindow(window)) {
      _rowVirtSuppressed = isRowSuppressed;
    }
  },
};
